import { Module } from 'vuex';

import { RecentLessonInfoState, RootState } from 'frontend/types';

export interface ContinueLearningState {
  items: RecentLessonInfoState[];
}

const continueLearning: Module<ContinueLearningState, RootState> = {
  namespaced: true,
  state: {
    items: [],
  } as ContinueLearningState,
  getters: {
    incompleteLessonsList: (state: ContinueLearningState): RecentLessonInfoState[] => {
      return state.items;
    },
  },
  mutations: {
    setValue(state: ContinueLearningState, value: RecentLessonInfoState[]): void {
      state.items = value;
    },
  },
  actions: {},
};

export default continueLearning;
